<template>
  <div class="container">
    <table
      id="dataReportColdChain"
      class="main"
    >
      <tr class="main-element">
        <th class="title-data">
          Empresa
        </th>
        <th class="data-element">
          {{ product?.companyName }}
        </th>
      </tr>

      <tr class="main-element .cold-chain-consulted uk-flex-wrap uk-flex ">
        <div
          style="width: 85%; flex-grow: 1;"
          class="uk-flex"
        >
          <th class="title-data">
            Cadena de Frío Consultada
          </th>
          <th class="data-element-sub">
            {{ product?.currentChainDescription }}
          </th>
        </div>
        <th
          id="dataNumElements"
          style="width: 15%; flex-grow: 1"
          class="sub-title-data"
        >
          <span class="num-element">No. Procesos</span>
          <span class="num-data">{{ coldChain.length }}</span>
        </th>
      </tr>
      <tr class="main-element">
        <th class="title-data">
          Producto
        </th>
        <th
          v-if="product?.selectedProducts && product.selectedProducts.length > 0"
          class="data-element"
        >
          {{ product.selectedProducts.map(x=>x.label.trim()).join(', ') }}
        </th>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      coldChain: 'coldChain',
      product: 'product'
    })
  },
  methods: {
    async downloadFile () {
      await this.$services.fileService.downloadFile('/ColdChain/download/perishables-manual')
    }
  }

}
</script>

<style scoped>
.container{
  margin: 25px 0px 30px;
}
.main{
  width: 100%;
  border-collapse: collapse;
}
.main-element{
  display: flex;
}

.main-element:nth-child(even){background-color: #f5f5f5;}

.main-element:hover {background-color: #ddd;}

th{
  padding: 10px 10px;
  text-align: left;
  color: white;
}

.title-data{
    border: 1px solid rgb(168, 167, 167);
    color: #fff;
    width: 20%;
    min-width: 140px;
    max-width: 188px;
    background: #014968;
    font-weight: 600;
}
.data-element{
    border: 1px solid rgb(168, 167, 167);
    width: 100%;
    min-width: 100px;
    color: #333;
    font-weight: 600;
}

.data-element-sub{
  width: 80%;
  flex-grow: 1;
  border: 1px solid rgb(168, 167, 167);
  min-width: 100px;
  color: #333;
}
.num-element{
  background: #014968;
  width: 80%;
  color: #fff;
  padding: 10px;
}
.num-data{
  background-color: #f5f5f5;
  width: 95%;
  color: #333;
  padding: 10px;

}
.sub-title-data{
  border: 1px solid rgb(168, 167, 167);
  width: 20%;
  padding: 0px;
  min-width: 100px;
  background: #0177aa;
  display: flex;
}
@media screen and (max-width: 940px ) {
  *{
    font-size: 10px;
  }
}
@media screen and (max-width: 700px ){
  .num-element{
    min-width: 140px;
    width: 140px;
    border-right: 2px solid rgb(168, 167, 167);

  }
}
</style>
